/**
 * Heuristic that flags a field whose label/key *looks* sensitive (IBAN, bank, tax id, ID card, SSN, credit
 * card…) so the builder can surface a non-blocking warning when the author hasn't marked it sensitive. This is
 * a nudge only — the authoritative sensitivity decision is the field type + the explicit `sensitive` flag.
 */

const SENSITIVE_KEYWORDS =
  /iban|konto|bank|bic|swift|ssn|sozial|sv-?nummer|steuer|tax\b|ausweis|perso|passport|reisepass|kreditkart|credit\s*card|\bcard\b|\bcvv\b/i;

/** True when the field's label or key matches a known-sensitive keyword. */
export function looksSensitive(field: { label?: string; key?: string }): boolean {
  const haystack = `${field.label ?? ''} ${field.key ?? ''}`.trim();
  return haystack.length > 0 && SENSITIVE_KEYWORDS.test(haystack);
}
